import React, { useState, useRef } from "react";
import LeftStudent from "../assets/images/public-pages/Student-group.png";
import Frame1 from "../assets/images/public-pages/iletsScore-frame1.jpg";
import Frame2 from "../assets/images/public-pages/iletsScore-frame2.jpg";
import Frame3 from "../assets/images/public-pages/iletsScore-frame3.jpg";
import Frame4 from "../assets/images/public-pages/iletsScore-frame4.jpg";
import Frame5 from "../assets/images/public-pages/iletsScore-frame5.jpg";
import Frame6 from "../assets/images/public-pages/iletsScore-frame6.jpg";
import Frame7 from "../assets/images/public-pages/iletsScore-frame7.jpg";
import Frame8 from "../assets/images/public-pages/iletsScore-frame8.jpg";
import Frame9 from "../assets/images/public-pages/iletsScore-frame9.jpg";
import Frame10 from "../assets/images/public-pages/iletsScore-frame10.jpg";
import Frame11 from "../assets/images/public-pages/iletsScore-frame11.jpg";
import Frame12 from "../assets/images/public-pages/iletsScore-frame12.jpg";
import Frame13 from "../assets/images/public-pages/iletsScore-frame13.jpg";
import Frame14 from "../assets/images/public-pages/iletsScore-frame14.jpg";
import Report from "../assets/images/public-pages/report.svg";
import ClassImg from "../assets/images/public-pages/class.png";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import SimpleReactValidator from "simple-react-validator";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import API from "api.js";
import { Helmet } from "react-helmet";
import Slider from "react-slick";
import PhoneInputField from "components/Inputs/PhoneInputField";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";
import BannerHeader from "components/PublicPagesReusable/BannerHeader";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import InfoSection from "components/PublicPagesReusable/InfoSection";
import AsianStudent from "../assets/images/public-pages/asianStudent.png";
import IeltsBannerBg from "../assets/images/public-pages/ieltsbannerbackground.png";
import imigrationtest from "../assets/images/public-pages/immigration-test.png"
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import Speaking from "../assets/images/public-pages/core-speaking.svg";
import Writing from "../assets/images/public-pages/core-writing.svg";
import Reading from "../assets/images/public-pages/core-reading.svg";
import Listening from "../assets/images/public-pages/core-listening.svg";
import CheckList from "../assets/images/public-pages/check-list.svg";
import Filter from "../assets/images/public-pages/filter.svg";
import Reward from "../assets/images/public-pages/reward.svg";
import TestSection from "components/PublicPagesReusable/TestSection";
import OnlinePricingTable from "components/PublicPagesReusable/OnlinePricingTable";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import ExamSkillsSection from "components/PublicPagesReusable/ExamSkillsSection";
import ExperiencedIcon from "../assets/images/public-pages/ExperiencedIcon.png";
import HighestIcon from "../assets/images/public-pages/HighestIcon.png";
import MaterialsIcon from "../assets/images/public-pages/MaterialsIcon.png";
import ResourceIcon from "../assets/images/public-pages/ResourceIcon.png";
import SupportIcon from "../assets/images/public-pages/SupportIcon.png";
import QuestionsIcon from "../assets/images/public-pages/QuestionsIcon.png";
import DiscussionIcon from "../assets/images/public-pages/DiscussionIcon.png";
import FeeIcon from "../assets/images/public-pages/FeeIcon.png";
import TestEnvironmentIcon from "../assets/images/public-pages/TestEnvironmentIcon.png";
import OurSuccessBg from "../assets/images/public-pages/oursuccessbackground.png";

const Pte = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [course, setCourse] = useState("IELTS Online");
  const [lang, setLang] = useState("Hindi");
  const [query, setQuery] = useState("");
  const [flag, setFlag] = useState(false);
  const [loginLock, setLoginLock] = useState(false);
  const navigate = useNavigate();

  const validator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
const sliderList = {
    title: "What Our <span>Students Say</span>",
    subtitle: "Real success stories from our learners",

    settings: {
      slidesToShow: 2.5,
      autoplay: true,
    },

    items: [
      {
        id: 1,
        name: "Anika Patel",
        location: "Gujarat, India",
        description:
          "Got Band 7.5 on my first attempt after months of self-study going nowhere. The writing feedback was detailed and specific — that alone was worth the enrolment fee.",
        image: "/images/web-new-images/new-content-slider/SahidaKhatun-demo.svg",
      },
      {
        id: 2,
        name: "Yuki Tanaka",
        location: "Osaka, Japan",
        description:
          "Reading and listening were always my weak points. The targeted practice modules addressed both specifically. Went from 6.5 to 7.5 in those skills in about eight weeks.",
        image: "/images/web-new-images/new-content-slider/DilmeetKingra-demo.svg",
      },
      {
        id: 3,
        name: "Hassan Ibrahim",
        location: "Cairo, Egypt",
        description:
          "Writing Task 2 used to take me 45 minutes and I'd still get Band 6. After learning how to structure arguments properly I now finish with time to spare and consistently hit 7.5.",
        image: "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
      },
      {
        id: 4,
        name: "Elena Kovács",
        location: "Budapest, Hungary",
        description:
          "I plateaued at Band 7 in speaking for months. The conversational coaching here identified exactly what was holding me back and pushed me to 8.0. Very much worth it.",
        image: "/images/web-new-images/new-content-slider/JayPatel-demo.svg",
      },
      {
        id: 5,
        name: "Neha Verma",
        location: "Pune, India",
        description:
          "Working full time, I needed evening slots. Three months of part-time study and I achieved my target 7.5 on the first sitting. Flexible scheduling made all the difference.",
        image: "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      },
      {
        id: 6,
        name: "Kwame Asante",
        location: "Kumasi, Ghana",
        description:
          "Grammar was always patchy for me. Teaching it in context rather than as abstract rules finally made things click. Got Band 7.5 in writing — first time I've ever been happy with that score.",
        image: "/images/web-new-images/new-content-slider/HamzaAghariya-demo.svg",
      },
    ]
  };

  const submitForm = (e) => {
    e.preventDefault();
    hitApi();
  };

  const hitApi = async () => {
    if (loginLock) return;
    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate((n) => n + 1);
      return;
    }
    setLoginLock(true);
    var bodyFormData = new FormData();
    bodyFormData.set("email", email);
    bodyFormData.set("name", name);
    bodyFormData.set("phone", phone);
    bodyFormData.set("message", "<b>course:</b> " + course + "<br/><b>Query:</b> " + query);
    bodyFormData.set("data", "email: " + email + ",name: " + name + ",phone: " + phone + ",course: " + course + ",query: " + query);
    bodyFormData.set("page", "IELTS coaching parramatta");
    let res = null;
    try {
      res = await API({ method: "POST", url: "sendOnlinePte", data: bodyFormData });
    } catch (error) { }
    if (res?.status === 200) {
      store.dispatch(setAlert({ flag: true, type: 1, message: res.data.message }));
      setName(""); setEmail(""); setPhone(""); setCourse("IELTS Online"); setQuery("");
      setLoginLock(false);
      setFlag(true);
    } else {
      setLoginLock(false);
    }
  };

  const changeInput = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "name": setName(value); break;
      case "email": setEmail(value); break;
      case "phone": setPhone(value); break;
      case "course": setCourse(value); break;
      case "lang": setLang(value); break;
      case "comments": setQuery(value); break;
      default: break;
    }
  };

  if (flag) return <Navigate to="/thank-you" replace />;

  const CardsSlider = {
    dots: true, arrows: true, infinite: true, speed: 500,
    slidesToShow: 1, slidesToScroll: 1, autoplay: true, adaptiveHeight: true, autoplaySpeed: 5000,
  };

  // ─── DATA ───

  const bannerTitle = () => (
    <h1 className="top-section-text mb-4 FS56FW500">
      Achieve Your Target <span className="text-success"> IELTS Band Score</span> With Parramatta's Leading Coaching Experts
    </h1>
  );

  const subTitleSection = () => (
    <p className="sub-title text-center FS16FW500">
      Expert instruction, proven strategies, and personalized support to help you achieve the band scores that open doors worldwide.
    </p>
  );

  const images = [
    { src: Frame1, alt: "score-1" }, { src: Frame2, alt: "score-2" }, { src: Frame3, alt: "score-3" },
    { src: Frame4, alt: "score-4" }, { src: Frame5, alt: "score-5" }, { src: Frame6, alt: "score-6" },
    { src: Frame7, alt: "score-7" }, { src: Frame8, alt: "score-8" },{ src: Frame9, alt: "score-9" }, 
    { src: Frame10, alt: "score-10" }, { src: Frame11, alt: "score-11" }, { src: Frame12, alt: "score-12" }, 
    { src: Frame13, alt: "score-13" },{ src: Frame14, alt: "score-14" }
  ];

  const skillAreaTitle = () => (
    <p className="top-section-text mb-4 FS40FW600">
      <span className="text-success">IELTS Exam </span>Tests<br />Four Key Skills
    </p>
  );

  const lifestyleCards = [
    { title: "Reading", text: "Comprehension, vocabulary, and critical analysis", color: "#7F56D9", img: Reading },
    { title: "Writing", text: "Grammar, essay composition, and task completion", color: "#0286FF", img: Writing },
    { title: "Listening", text: "Understanding accents, identifying key points, and following instructions", color: "#FFB02C", img: Listening },
    { title: "Speaking", text: "Pronunciation, fluency, and clear communication", color: "#48A75C", img: Speaking },
  ];

  const whyChooseCards = [
    { title: "Global Recognition", text: "Accepted by over 11,000 organizations in 140+ countries, including universities, employers, and immigration authorities worldwide", color: "transparent", img: CheckList },
    { title: "Multiple Test Formats", text: "Choose between IELTS Academic for university admissions or IELTS General Training for work and migration purposes", color: "transparent", img: Filter },
    { title: "Comprehensive Scoring", text: "Detailed band scores across all four skills give you a clear picture of your English proficiency strengths and areas for improvement", color: "transparent", img: Reward },
    { title: "Flexible Test Scheduling", text: "Multiple test dates available throughout the year at convenient locations, with both paper-based and computer-delivered options", color: "transparent", img: CheckList },
    { title: "Connect with Migration Authorities", text: "IELTS is the most widely accepted English test for Australian, UK, Canadian, and New Zealand immigration applications", color: "transparent", img: Reward },
  ];

  const testSectionData = {
    title: "Master Every Section Of The",
    highlight: "IELTS Exam",
    subtitle: "With Our Proven Strategies",
    description: "Our specialized training helps you excel in every component of the IELTS exam",
    tabs: [
      { label: "Speaking", icon: <img src="/images/web-new-images/icons/w-speak-icon.svg" alt="Speaking" />, content: { leftTitle: "What It Tests", leftPoints: ["Fluency, pronunciation, and clarity of expression."], rightTitle: "Our Approach", rightPoints: ["Practice with mock interviews, fluency drills, and AI-supported pronunciation tools."] } },
      { label: "Writing", icon: <img src="/images/web-new-images/icons/w-write-icon.svg" alt="Writing" />, content: { leftTitle: "What It Tests", leftPoints: ["Grammar, essay structuring, and articulation of ideas."], rightTitle: "Our Approach", rightPoints: ["Learn high-scoring templates, refine grammar, and structure essays effectively."] } },
      { label: "Reading", icon: <img src="/images/web-new-images/icons/w-reading-icon.svg" alt="Reading" />, content: { leftTitle: "What It Tests", leftPoints: ["Vocabulary, speed, and critical reading skills."], rightTitle: "Our Approach", rightPoints: ["Time management techniques, skimming/scanning, and comprehension-building exercises."] } },
      { label: "Listening", icon: <img src="/images/web-new-images/icons/w-listen-icon.svg" alt="Listening" />, content: { leftTitle: "What It Tests", leftPoints: ["Understanding accents, identifying details, and following conversations."], rightTitle: "Our Approach", rightPoints: ["Active listening exercises, accent training, and answering strategies."] } },
    ],
    cta: "READY TO EXCEL IN EVERY SECTION OF THE IELTS TEST? ENROLL WITH US NOW",
  };


  const pricingPlans = [
    {
      title: "Online Coaching",
      description: "Everything in the Online Platform package, PLUS",
      price: "249",
      features: [
        "Live Virtual Classes",
        "Personalized Feedback",
        "Direct Trainer Access",
        "Priority Support",
      ],
      buttonText: "Start Your Plan",
      isPopular: true,
      badgeText: "BEST SELLER",
    },
    {
      title: "Campus Coaching",
      description: "Everything in the IELTS online course package, PLUS",
      price: "249",
      features: [
        "In-Person Training",
        "One-On-One Sessions",
        "Intensive Workshops",
        "Extended Support",
        "Exam Booking Assistance",
      ],
      buttonText: "Start Your Plan",
      isPopular: false,
    },
  ];

  const ieltsFaqQuestions = [
    { question: "How long will I need to prepare for IELTS?", answer: "Most candidates typically need 6–8 weeks of focused preparation depending on their current skill level." },
    { question: "Where exactly is your Parramatta campus located?", answer: "Our campus is located at 246 George Street, Parramatta, 2150, NSW, Australia, right next to George Street with easy access to public transport and secured parking." },
    { question: "Are classes available online or in-person in Parramatta?", answer: "Yes! We offer both online and in-person classes at our Parramatta campus located at 246 George Street. You can choose the format that best suits your schedule and learning style." },
    { question: "What is the difference between IELTS Academic and General Training?", answer: "IELTS Academic is designed for students seeking admission to universities or professional registration. IELTS General Training is for those migrating to English-speaking countries for work or non-academic purposes." },
    { question: "How can I book a free demo class?", answer: "You can book a free demo class by clicking the Register button on our website, calling our Parramatta campus directly, or visiting us in person at 246 George Street, Parramatta." },
    { question: "Do you provide past exam questions for practice?", answer: "Yes, we have an extensive repository of past exam questions with detailed answers and explanations that help students familiarize themselves with the exam format and question types." },
    { question: "What makes Language Academy different from other IELTS coaching centers?", answer: "Language Academy stands out with experienced trainers, personalized study plans, unlimited practice tests, real-time test simulations, and a proven track record of students consistently achieving 8+ band scores." },
    { question: "What kind of support do you provide during the course?", answer: "We provide comprehensive support including direct trainer access, personalized feedback on your performance, priority support for any challenges, and ongoing guidance throughout your preparation journey." },
  ];

  // ─── Reusable checkmark SVG ───
  const CheckSvg = () => (
    <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 1.49072L6 12.4907L1 7.49072" stroke="#48A75C" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );

  return (
    <React.Fragment>
      <Helmet>
        <title>IELTS Coaching Classes in Parramatta | LA Language Academy</title>
        <meta name="description" content="Achieve your IELTS goals with LA Language Academy. Attend the best IELTS coaching classes in Parramatta and get personalized instruction & comprehensive practice." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.languageacademy.com.au/ielts-coaching-parramatta" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="IELTS Coaching Classes in Parramatta | LA Language Academy" />
        <meta name="twitter:description" content="Achieve your IELTS goals with LA Language Academy. Attend the best IELTS coaching classes in Parramatta and get personalized instruction & comprehensive practice." />
        <meta name="twitter:image" content="https://www.languageacademy.com.au/images/logol.png" />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content="https://www.languageacademy.com.au/ielts-coaching-parramatta" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="IELTS Coaching Classes in Parramatta | LA Language Academy" />
        <meta property="og:description" content="Achieve your IELTS goals with LA Language Academy. Attend the best IELTS coaching classes in Parramatta and get personalized instruction & comprehensive practice." />
        <meta property="og:image" content="https://www.languageacademy.com.au/images/logol.png" />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>
      <div className="new-design">
        <div className="innerPage">
          <Header />

          {/* 1. HERO BANNER */}
          <BannerHeader
            title={bannerTitle}
            subTitle={subTitleSection}
            backgroundColor="#fff"
            textColor="black"
            backgroundImage={IeltsBannerBg}
            btnText="ENROLL In Our Comprehensive IELTS Program Today"
            middleSection={() => (
              <div id="banner-hero-section" style={{ marginTop: "50px" }}>
                <img src={LeftStudent} alt="Student" style={{ width: '100%', maxHeight: '500px', objectFit: 'contain' }} />
              </div>
            )}
          />

          {/* 2. SCORE CARDS SLIDER */}
          <div className="fame-wall" style={{ paddingTop: "unset" }}>
            <ReusableHomePageSlider images={images} />
          </div>

          {/* 3. DESCRIPTION BELOW SLIDER */}
          <div className="custom-container py-5 text-center">
            <p className="plus-sans FS16FW500 mx-auto" style={{ maxWidth: '936px', color: '#525252', lineHeight: '160%' }}>
              Achieve your dream IELTS band score and unlock opportunities with expert IELTS coaching tailored for students, language learners, and IELTS candidates. As Parramatta's top-rated IELTS coaching centre, we specialize in personalized strategies to help you improve your English skills, ace the IELTS exam, and reach your goals, whether it's qualifying for migration, pursuing higher education, or enhancing your career prospects.
            </p>
          </div>

          {/* 4. WHAT IS IELTS - same structure as vc-journey-section */}
          <div className="vc-journey-section">
            <div className="custom-container py-5">
              <div className="row align-items-center justify-content-between content-image-section">
                <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
                  <p className="top-section-text FS40FW600">
                    <em className="green-text">What Is IELTS?</em><br />
                    Your Gateway To A Brighter Future
                  </p>
                  <div className="quote-box mt-3 FS18FW400 black" style={{ borderLeft: '4px solid #94C23C', paddingLeft: '12px' }}>
                    The International English Language Testing System (IELTS) is a globally recognized English proficiency test designed for academic, professional, and migration purposes.
                  </div>
                  <p className="mt-3 FS17FW500 quote-para">
                    IELTS assesses and gives an internationally recognized certificate to people successfully qualifying it. Like other countries, the Australian government also accepts IELTS valid scores as a prerequisite for migrating to Australia.
                  </p>
                  <p className="mt-3 FS17FW500 quote-para">
                    Accepted by universities, immigration authorities, and employers worldwide, IELTS assesses your ability to communicate effectively in English across four core skills—listening, reading, writing, and speaking.
                  </p>
                  <ButtonComp btnText="Register For Free" link="/auth/register" className="mt-2" />
                </div>
                <div className="col-lg-6 col-md-12 cis-image-col">
                  <img className="cis-image" src={imigrationtest} alt="IELTS Preparation" />
                </div>
              </div>
            </div>
          </div>

          {/* 5. IELTS EXAM TESTS FOUR KEY SKILLS - SkillAreas */}
          <SkillAreas
            skillAreaTitle={skillAreaTitle}
            lifestyleCards={lifestyleCards}
            btnText={"Begin Your IELTS Success Journey With Us Today"}
            skillSubtitle={"The IELTS exam score ranges between 0 and 9 and the exam is conducted in two categories:"}
            MiddleInfoSection={[
              "IELTS General Training and IELTS Academic Training. Students migrating to Parramatta, Australia to attend a course can opt for IELTS Academic Training. Whereas, anyone migrating for all other non-educational purposes can take IELTS General Training.",
              "IELTS also helps candidates qualify for migration and academic opportunities in countries like Australia, the UK, Canada, and more."
            ]}
            skillBottomtitle={"With the right preparation and expert guidance, you won't just pass the exam, you'll gain the confidence and skills to thrive in any English-speaking environment."}
          />

          {/* 6. WHY CHOOSE IELTS - SkillAreas (white variant) */}
          <SkillAreas
            className={"skill-section"}
            background={"white"}
            color={"black"}
            skillAreaTitle={() => (
              <p className="top-section-text mb-4 FS40FW600">
                Why Choose <span className="text-success">IELTS?</span> Here's<br />Why It's The Right Choice For You
              </p>
            )}
            lifestyleCards={whyChooseCards}
            btnText={"Start Your Preparation Now"}
            skillSubtitle={"Our IELTS coaching offers comprehensive resources to help you understand these key advantages"}
          />

          {/* 8. IELTS TRAINING IN PARRAMATTA - InfoSection */}
          <InfoSection
            title="IELTS Training In Parramatta:"
            subtitle="The Perfect Place To Prepare!"
            description="Parramatta is a thriving hub for education, offering IELTS candidates the perfect blend of resources and opportunities."
            buttonText="Discover Why Parramatta Students Choose Us"
            buttonAction={() => window.location.href = '/contact'}
            image={AsianStudent}
            imageCaption="This vibrant city is home to a diverse community of students and professionals, making it an ideal place for language learners aiming to excel in English. With its supportive environment and easy access to resources, Parramatta empowers learners to achieve their IELTS goals."
            rightTitle="Our Convenient Parramatta Location"
            rightDescription="Language Academy's Parramatta campus is located at the center of the city at 246 George Street, Parramatta, 2150, NSW, Australia, right next to George Street. The building has numerous food and beverage outlets nearby, and we provide secured parking for all students and experts right in the basement of our building."
            features={[
              { title: "Easy access", items: ["Short walk from the bus stop at Parramatta interchange", "Parramatta station is just a short walk from the campus", "Public transport facilities can be easily accessed in just a few minutes"] },
              { title: "Whether you're planning on", items: ["Migrating to an English-speaking country", "Pursuing higher education abroad", "Advancing your career opportunities"] },
            ]}
            footerText="Language Academy is your trusted partner for IELTS preparation course in Parramatta, helping students reach their ultimate goal of achieving high band scores with confidence."
          />

          {/* 9. IELTS TRAINING WITH LANGUAGE ACADEMY - same structure as vc-journey-section */}
          <div className="vc-journey-section">
            <div className="custom-container py-5">
              <div className="row align-items-center justify-content-between content-image-section">
                <div className="col-lg-5 col-md-12 mb-4 mb-lg-0">
                  <p className="top-section-text FS40FW600">
                    <em className="green-text">IELTS Training</em> In Parramatta<br />With Language Academy
                  </p>
                  <div className="quote-box mt-3 FS17FW500" style={{ borderLeft: '4px solid #94C23C', paddingLeft: '12px' }}>
                    At Language Academy, our IELTS training course is proven to be quite effective in improving our students' English acumen. Expert faculties with finest subject matter expertise and best teaching methodology create personalized curriculum for each student.
                  </div>
                  <p className="mt-3 FS17FW500 quote-para" style={{ borderLeft: 'none' }}>
                    Students can quickly start peaking their scores as our stringent curriculum includes a lot of practice, assessment, and feedback. We get an immensely large number of positive reviews for our impeccable IELTS training in Parramatta.
                  </p>
                  <p className="mt-3 FS17FW500 quote-para" style={{ borderLeft: 'none' }}>
                    Learners attending our IELTS training course praise us a lot and even share with us how much they enjoy taking part in all dimensions of English activities. They tell us that they even excel at times in different sorts of personal, professional, and cultural activities.
                  </p>
                  <ButtonComp btnText="Experience Our Proven Approach" link="/auth/register" className="mt-2" />
                </div>
                <div className="col-lg-6 col-md-12 cis-image-col">
                  <img className="cis-image" src={imigrationtest} alt="IELTS Training" />
                </div>
              </div>
            </div>
          </div>

          {/* 10. PERSONALIZED PATH */}
          <div className="test-section py-5" style={{ "--section-bg": "#080F1E" }}>
            <div className="custom-container text-center">
              <h2 className="main-title FS40FW600">
                The Personalized Path To <span className="text-success FS40FW600">IELTS Success</span><br />In Parramatta
              </h2>
              <p className="FS16FW500 plus-sans mt-3 white" style={{ maxWidth: '906px', margin: '0 auto' }}>
                Struggling with IELTS preparation or worried about securing your target band scores? You're not alone. Many students face similar challenges, but at Language Academy, our IELTS coaching is designed to help you:
              </p>
              <div className="row g-4 justify-content-center mt-4">
                {[
                  { title: "Boost your English proficiency", desc: "across all key skills, Listening, Reading, Writing, and Speaking." },
                  { title: "Build thorough preparation strategies", desc: "for every section of the IELTS exam." },
                  { title: "Gain confidence", desc: "to tackle high-pressure test environments." },
                ].map((card, i) => (
                  <div key={i} className="col-lg-4 col-md-6">
                    <div className="d-flex align-items-start gap-3 text-start">
                      <div className="d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '46px', height: '46px', background: '#0286FF', borderRadius: '8px' }}>
                        <img src="/images/web-new-images/yourApprochIcon.svg" alt="" style={{ width: '24px', height: '24px' }} />
                      </div>
                      <div>
                        <h5 className="plus-sans fw-700 white mb-2" style={{ fontSize: '20px', lineHeight: '120%' }}>{card.title}</h5>
                        <p className="plus-sans fw-500 white mb-0" style={{ fontSize: '16px', lineHeight: '28px' }}>{card.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-4">
                <ButtonComp btnText="Experience Our Proven Approach" link="/auth/register" className="mt-3" />
              </div>
            </div>
          </div>

       

          {/* 10b. WHAT MAKES US YOUR BEST CHOICE */}
          <div className="ielts-best-choice-section">
            <div className="custom-container py-5">
              <h2 className="top-section-text FS40FW600 text-center mb-5">
                What Makes Us Your Best Choice For <em className="green-text">IELTS Coaching Classes</em> in Parramatta?
              </h2>
              <div className="row align-items-center justify-content-between">
                <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
                  <p className="FS16FW300 poppins-font" style={{ color: '#0D1830' }}>
                    Parramatta offers access to numerous English training facilities, and Language Academy is proud to stand out as one of the most trusted IELTS coaching centre in the area. IELTS classes in Parramatta like Language Academy offer both IELTS online course and offline courses.
                  </p>
                  <p className="FS17FW500 plus-sans mt-3" style={{ color: '#383838' }}>
                    With our modern classrooms, expert tutors, and tailored coaching solutions, we ensure that every student receives personalized support based on their strengths and weaknesses. Here's how we guarantee your success:
                  </p>
                  <div className="d-flex flex-column gap-3 mt-4">
                    <div className="d-flex align-items-start gap-3">
                      <img src="/images/web-new-images/icons/green-check.svg" alt="" style={{ width: '24px', marginTop: '4px' }} />
                      <p className="mb-0 plus-sans" style={{ fontSize: '18px', lineHeight: '150%', color: '#141414' }}>
                        Comprehensive study materials and simulated test environments to build familiarity and confidence
                      </p>
                    </div>
                    <div className="d-flex align-items-start gap-3">
                      <img src="/images/web-new-images/icons/green-check.svg" alt="" style={{ width: '24px', marginTop: '4px' }} />
                      <p className="mb-0 plus-sans" style={{ fontSize: '18px', lineHeight: '150%', color: '#141414' }}>
                        Expert-led 1:1 coaching sessions to focus on individual improvement areas
                      </p>
                    </div>
                    <div className="d-flex align-items-start gap-3">
                      <img src="/images/web-new-images/icons/green-check.svg" alt="" style={{ width: '24px', marginTop: '4px' }} />
                      <p className="mb-0 plus-sans" style={{ fontSize: '18px', lineHeight: '150%', color: '#141414' }}>
                        Proven strategies that help our students consistently achieve their desired band scores
                      </p>
                    </div>
                  </div>
                  <ButtonComp btnText="Book Your Consultation Today" link="/contact" className="mt-4" />
                </div>
                <div className="col-lg-5 col-md-12 position-relative">
                  <div className="position-relative">

                    <img
                      src={imigrationtest}
                      alt="IELTS Coaching"
                      className="img-fluid position-relative"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 11b. YOUR BENEFITS WITH LANGUAGE ACADEMY - SkillAreas */}
          <SkillAreas
            className="skill-section"
            background="white"
            color="black"
            skillAreaTitle={() => (
              <p className="top-section-text mb-4 FS40FW600">
                Your Benefits With <span className="text-success"><em>Language Academy</em></span>
              </p>
            )}
            lifestyleCards={[
              { title: "Personalized Study Plans", text: "Targeted strategies to help you maximize your potential.", color: "transparent", img: CheckList },
              { title: "Real-Time Test Simulations", text: "Experience the exact pressure of an IELTS test environment.", color: "transparent", img: Filter },
              { title: "Unlimited Practice Tests", text: "Refine your skills with comprehensive materials and assessments.", color: "transparent", img: Reward },
              { title: "1:1 Tutorials with Experts", text: "Get personalized guidance for every exam section.", color: "transparent", img: CheckList },
              { title: "Confidence-Boosting Sessions", text: "Overcome exam stress and perform at your best.", color: "transparent", img: Reward },
            ]}
            btnText="Book Your Consultation Today"
            skillSubtitle="Stop struggling and start succeeding with Language Academy, where expert training and proven techniques come together for your IELTS success."
          />

          {/* 12. WHY CHOOSE LANGUAGE ACADEMY - ExamSkillsSection */}
          <ExamSkillsSection
            title="Why Choose Language Academy"
            highlight="IELTS"
            subtitle="Training In Parramatta"
            ctaText="Register For A Free Trial Sessions For IELTS"
            onCtaClick={() => navigate('/auth/register')}
            cards={[
              {
                icon: ExperiencedIcon,
                title: "Experienced Trainers",
                content: `<div>They are adept at both linguistics skills and imparting educational lectures both online and in-person.</div>`
              },
              {
                icon: HighestIcon,
                title: "Highest Success Rate",
                content: `<div>With detailed and well-planned learning modules, we are able to give the best training to our students, and they are constantly achieving 8+ band scores.</div>`
              },
              {
                icon: MaterialsIcon,
                title: "Free Intensive Material",
                content: `<div>Our templates make it easier for any student to self-learn quickly from the framework and follow them to achieve the best scores.</div>`
              },
              {
                icon: ResourceIcon,
                title: "Latest Resources",
                content: `<div>Our students get access to our comprehensive learning resources and online platform.</div>`
              },
              {
                icon: SupportIcon,
                title: "Online Support",
                content: `<div>Our experts are always available for any student. You can reach out to any trainer and ask questions or seek help in solving any doubts that you have.</div>`
              },
              {
                icon: QuestionsIcon,
                title: "Past Exam Questions to Practices",
                content: `<div>We have a repository of past exam questions with answers to practice from that can help any student to quickly practice previous year's questions.</div>`
              },
              {
                icon: DiscussionIcon,
                title: "Discussion Sessions",
                content: `<div>Our faculties carefully assess the level of students during discussion sessions and suggest personalized study plans.</div>`
              },
              {
                icon: FeeIcon,
                title: "Affordable Fees",
                content: `<div>We have kept the IELTS course fee reasonable so that every student can easily afford to pay the costs on their own.</div>`
              },
              {
                icon: TestEnvironmentIcon,
                title: "Real-Time Test Environment",
                content: `<div>We assess all our students from time to time and give them a real-time test environment, so they acclimate to the actual test environment and feel less stressed during the actual test.</div>`
              }
            ]}
          />

          {/* 13. MASTER EVERY SECTION - TestSection */}
          <TestSection data={testSectionData} />

          {/* 14. RECORDS & ACHIEVEMENTS - Our Success */}
          <div className="custom-container py-5 text-center position-relative" style={{ overflow: 'hidden', backgroundImage: `url(${OurSuccessBg})`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
            <h2 className="FS40FW600 mb-3" style={{ fontFamily: "'Tropiline', sans-serif", fontStyle: 'italic', color: '#94C23C' }}>
              Our Success<br />
              <span style={{ fontFamily: "'Bricolage Grotesque', serif", fontStyle: 'normal', color: '#141414' }}>Records & Student Achievements</span>
            </h2>
            <p className="plus-sans fw-700 mb-4" style={{ fontSize: '20px', color: '#141414' }}>
              Our Impressive Statistics For IELTS
            </p>
            <div className="d-flex justify-content-center flex-wrap gap-5">
              {[
                { number: "500+", label: "Coaching Preview Sessions Completed" },
                { number: "2000+", label: "Registered Students" },
                { number: "1000+", label: "Successful Students Achieving Target Scores" },
              ].map((stat, idx) => (
                <div key={idx} className="d-flex flex-column align-items-center" style={{ width: '216px' }}>
                  <h3 style={{ fontFamily: "'Bricolage Grotesque', serif", fontWeight: 800, fontSize: '48px', lineHeight: '120%', color: '#141414', margin: 0 }}>{stat.number.replace('+', '')}<span style={{ color: '#48A75C' }}>+</span></h3>
                  <p className="plus-sans" style={{ fontSize: '16px', lineHeight: '24px', color: '#686868', margin: '12px 0 0', textAlign: 'center' }}>{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <TestimonialSection
            title={`<span class="hero-title FS40FW600 text-center mb-md-0">Hear from <span class="green-text">Our Students`}
            subtitle="We're dedicated to your success because your dreams matter to us."
            btnText="Join Our Success Stories"
            btnLink="/auth/register"
            sliderList={sliderList}
          />

          {/* 16. WHAT YOU WILL GET */}
          <div className="custom-container py-5">
            {/* Top: Title left + Description & CTA right */}
            <div className="d-flex flex-wrap justify-content-between align-items-start mb-5 gap-4">
              <h2 className="top-section-text FS40FW600 mb-0">
                What You Will <span className="green-text"><em>Get</em></span><br />
                <span className="green-text"><em>With Us</em></span>
              </h2>
              <div className="d-flex flex-column align-items-start gap-4" style={{ maxWidth: '520px' }}>
                <p className="plus-sans FS16FW500 mb-0" style={{ color: '#0D1830' }}>
                  Our comprehensive IELTS preparation course includes:
                </p>
                <ButtonComp btnText="Experience Our Comprehensive Approach" link="/auth/register" />
              </div>
            </div>

            {/* Bottom: Left list + Center image + Right list */}
            <div className="row g-4 align-items-start">
              {/* Left column - 4 items */}
              <div className="col-lg-4">
                <div className="d-flex flex-column gap-4">
                  {[
                    { title: "Unlimited Classes", desc: "Attend as many sessions as you need until you master every IELTS skill" },
                    { title: "Unlimited Writing & Speaking Assessments", desc: "Get continuous feedback to perfect your weakest areas without restrictions" },
                    { title: "1-to-1 Tutorial with Expert Tutor", desc: "Receive personalized attention tailored to your specific learning needs and goals" },
                    { title: "Comprehensive Practice Question Bank", desc: "Access thousands of real exam-style questions to build unshakeable confidence" },
                  ].map((item, i) => (
                    <div key={i} className="d-flex gap-2">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 mt-1">
                        <path d="M4 12L9 17L20 6" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <div>
                        <h5 className="plus-sans fw-700 mb-1" style={{ fontSize: '20px', lineHeight: '150%', color: '#141414' }}>{item.title}</h5>
                        <p className="plus-sans fw-400 mb-0" style={{ fontSize: '16px', lineHeight: '150%', color: '#686868' }}>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Center - Image */}
              <div className="col-lg-4">
                <img
                  src={ClassImg}
                  alt="IELTS Preparation"
                  className="w-100 rounded-4"
                  style={{ height: '488px', objectFit: 'cover', border: '1px solid rgba(0,0,0,0.05)' }}
                />
              </div>

              {/* Right column - 4 items */}
              <div className="col-lg-4">
                <div className="d-flex flex-column gap-4">
                  {[
                    { title: "Proven Method Lessons", desc: "Learn insider techniques and strategies that consistently produce high band scores" },
                    { title: "Foundation Overview Classes", desc: "Build rock-solid fundamentals before diving into advanced test-taking strategies" },
                    { title: "Strategic Pre-Test Preparation Sessions", desc: "Enter your exam with a winning game plan and zero surprises" },
                    { title: "Post-Test Success Consultations", desc: "Get expert analysis of your results and guidance for future improvement" },
                  ].map((item, i) => (
                    <div key={i} className="d-flex gap-2">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="flex-shrink-0 mt-1">
                        <path d="M4 12L9 17L20 6" stroke="#94C23C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <div>
                        <h5 className="plus-sans fw-700 mb-1" style={{ fontSize: '20px', lineHeight: '150%', color: '#141414' }}>{item.title}</h5>
                        <p className="plus-sans fw-400 mb-0" style={{ fontSize: '16px', lineHeight: '150%', color: '#686868' }}>{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* 17. PRICING - OnlinePricingTable */}
          <OnlinePricingTable
            title="Start Your"
            highlight={<em>IELTS</em>}
            secondTitle={<><br/><span className="text-success"><em>Journey</em></span> Today</>}
            subtitle="Choose Your Preparation Package — Starting from $249"
            plans={pricingPlans}
          />

          {/* 18. FAQ */}
          <FaqSection
            title={<>Frequently Asked <span className="green-text">Questions</span></>}
            questions={ieltsFaqQuestions}
          />

          <Footer />

          {/* DEMO CLASS MODAL */}
          <div className="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog main-popup">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img className="img-fluid" src="/images/web-new-images/icons/close-icon2.svg" alt="LA" /></span>
                  </button>
                </div>
                <div className="modal-body p-0">
                  <div className="form-content-outer m-0">
                    <div className="form-content">
                      <div className="main-popup-img form-img"><img className="img-fluid" src="/images/web-new-images/hero_img1.png" alt="LA" /></div>
                      <div className="main-popup-content form-content-right">
                        <h4 className="popup-title">Take a FREE Demo Class</h4>
                        <p className="popup-sub-title">Submit Your Details Below</p>
                        <div className="pte-popup-form-start">
                          <form onSubmit={submitForm}>
                            <div className="fieldOuter">
                              <label htmlFor="name">Name*</label>
                              <div className="form-input-outer"><input className="form-input" type="text" name="name" placeholder="Name*" value={name} onChange={changeInput} /></div>
                              {validator.current.message("Name", name, "required")}
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="PhoneNumber">Phone Number</label>
                              <PhoneInputField id="PhoneNumber" value={phone} addClass="popup-class" />
                              {validator.current.message("phone", phone, "required|phone")}
                              <span className="err phone-error"></span>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="email">Email*</label>
                              <div className="form-input-outer"><input className="form-input" type="email" name="email" placeholder="Email*" value={email} onChange={changeInput} /></div>
                              {validator.current.message("Email", email, "required")}
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="center">Center</label>
                              <div className="form-input-outer form-select-wrapper">
                                <select className="form-input" id="center" name="course" value={course} onChange={changeInput}>
                                  <option value="IELTS Online">IELTS Online</option>
                                  <option value="IELTS On-Campus">IELTS On-Campus</option>
                                  <option value="PTE On-Campus">PTE On-Campus</option>
                                  <option value="PTE Online">PTE Online</option>
                                  <option value="NAATI CCL Online">NAATI CCL Online</option>
                                  <option value="NAATI CCL On-Campus">NAATI CCL On-Campus</option>
                                </select>
                              </div>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="comments">Language</label>
                              <div className="form-input-outer form-select-wrapper">
                                <select className="form-input" name="lang" value={lang} onChange={changeInput}>
                                  <option value="Hindi">Hindi</option>
                                  <option value="Punjabi">Punjabi</option>
                                  <option value="Urdu">Urdu</option>
                                  <option value="Nepali">Nepali</option>
                                  <option value="Bangla">Bangla</option>
                                  <option value="Tamil">Tamil</option>
                                  <option value="Telugu">Telugu</option>
                                  <option value="Sinhalese">Sinhalese</option>
                                </select>
                              </div>
                            </div>
                            <div className="fieldOuter">
                              <label htmlFor="comments">Comments / Query</label>
                              <div className="form-input-outer"><input type="text" className="form-input" name="comments" placeholder="Enter your comments/Query" value={query} onChange={changeInput} /></div>
                              {validator.current.message("Query", query, "required")}
                            </div>
                            <div className="fieldOuter mb-0">
                              {!loginLock && <button className="primary-btn" onClick={hitApi}>SUBMIT <img className="img-fluid" src="/images/web-new-images/right-arrow.svg" alt="LA" /></button>}
                              {loginLock && <button className="primary-btn">Wait...</button>}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Pte;
